<template>
  <div class="tabs_content_left">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'sidebar'
}
</script>
